import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-084d567b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "feed-action-buttons__container" }
const _hoisted_2 = { class: "feed-action-buttons__btn-inner" }
const _hoisted_3 = { class: "feed-action-buttons__btn-text" }
const _hoisted_4 = { class: "feed-action-buttons__btn-inner" }
const _hoisted_5 = { class: "feed-action-buttons__btn-text" }
const _hoisted_6 = { class: "feed-action-buttons__btn-inner" }
const _hoisted_7 = { class: "feed-action-buttons__btn-text" }
const _hoisted_8 = { class: "feed-action-buttons__btn-inner" }
const _hoisted_9 = { class: "feed-action-buttons__btn-text" }
const _hoisted_10 = { class: "feed-action-buttons__btn-inner" }
const _hoisted_11 = { class: "feed-action-buttons__btn-text" }

import { ref, watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { IonIcon } from '@ionic/vue';
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import { logEvent } from '@/services/analytics';

import BaseButton from '@/components/BaseButton.vue';
import { useInternalization } from '@/composables/useInternalization';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationTapbar',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const { t } = useInternalization();

const isHide = ref(route.meta.hideTapbar);

watch(
  () => route.meta.hideTapbar,
  () => (isHide.value = route.meta.hideTapbar)
);

onMounted(() => {
  if (Capacitor.isNativePlatform()) {
    Keyboard.addListener('keyboardWillShow', () => {
      if (!route.meta.hideTapbar) {
        isHide.value = true;
      }
    });
    Keyboard.addListener('keyboardDidHide', () => {
      if (!route.meta.hideTapbar) {
        isHide.value = false;
      }
    });
  }
});

function isActiveLink(routePath: string) {
  return route.path.startsWith(`/${routePath}`);
}

function scrollToTop() {
  const activeIonContentEl = document
    .querySelector('.ion-page .ion-page:not(.ion-page-hidden)')
    ?.querySelector('ion-content');
  if (activeIonContentEl) {
    activeIonContentEl.shadowRoot
      ?.querySelector('.inner-scroll')
      ?.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

function handleFeedClick() {
  if (isActiveLink('feed')) {
    scrollToTop();
    return;
  }
  router.push({ name: 'Feed' });
}

function handleTherapyClick() {
  if (isActiveLink('therapy')) {
    scrollToTop();
    return;
  }

  router.push({ name: 'Therapy' });
}

function handleHelpClick() {
  if (isActiveLink('help')) {
    scrollToTop();
    return;
  }

  router.push({ name: 'Help' });
}

function handleStoriesClick() {
  if (isActiveLink('stories')) {
    scrollToTop();
    return;
  }

  router.push({ name: 'Stories' });
}

function handleProfileClick() {
  logEvent('topbar_click_profile');

  if (isActiveLink('my-profile')) {
    scrollToTop();
    return;
  }

  router.push({ name: 'MyProfile' });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['feed-action-buttons', { 'feed-action-buttons--hide': isHide.value }]),
    slot: "fixed",
    vertical: "bottom"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BaseButton, {
        class: _normalizeClass([
          'feed-action-buttons__btn',
          { 'feed-action-buttons__btn--active': isActiveLink('feed') },
        ]),
        primary: "",
        onClick: handleFeedClick
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(IonIcon), { icon: "/assets/icon/feed.svg" }),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('feed')), 1)
          ])
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(BaseButton, {
        class: _normalizeClass([
          'feed-action-buttons__btn',
          { 'feed-action-buttons__btn--active': isActiveLink('therapy') },
        ]),
        primary: "",
        onClick: handleTherapyClick
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(IonIcon), { icon: "/assets/icon/therapy.svg" }),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('therapy')), 1)
          ])
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(BaseButton, {
        class: _normalizeClass([
          'feed-action-buttons__btn',
          'feed-action-buttons__btn--help',
          { 'feed-action-buttons__btn--active': isActiveLink('help') },
        ]),
        primary: "",
        onClick: handleHelpClick
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(IonIcon), {
              icon: "/assets/icon/help.svg",
              size: "48"
            }),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('help')), 1)
          ])
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(BaseButton, {
        class: _normalizeClass([
          'feed-action-buttons__btn',
          { 'feed-action-buttons__btn--active': isActiveLink('stories') },
        ]),
        id: "speak-out-btn",
        primary: "",
        onClick: handleStoriesClick
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(IonIcon), { icon: "/assets/icon/stories.svg" }),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('stories')), 1)
          ])
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(BaseButton, {
        class: _normalizeClass([
          'feed-action-buttons__btn',
          { 'feed-action-buttons__btn--active': isActiveLink('my-profile') },
        ]),
        primary: "",
        onClick: handleProfileClick
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_unref(IonIcon), { icon: "/assets/icon/profile.svg" }),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('profile')), 1)
          ])
        ]),
        _: 1
      }, 8, ["class"])
    ])
  ], 2))
}
}

})